// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../static/inspection.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inspection-page{
    margin:0;
    padding-top:90px;
    box-sizing:border-box;
    font-family:'Inter',sans-serif;
    background:#f5f7fa;
}

/* SECTION */

.inspection-page-section{

    padding:90px 8%;
    background:#ffffff;

}

.inspection-page-container{

    max-width:1200px;
    margin:auto;

}

.inspection-page-subtitle{

    color:#E53935;
    font-weight:700;
    letter-spacing:2px;
    text-transform:uppercase;
    margin-bottom:15px;

}

.inspection-page-title{

    font-size:48px;
    font-weight:800;
    color:#111827;
    margin-bottom:20px;

}

.inspection-page-description{

    font-size:18px;
    color:#6b7280;
    max-width:850px;
    line-height:1.8;
    margin-bottom:60px;

}

/* Cards */

.inspection-page-cards{

    display:grid;
    grid-template-columns:repeat(3,1fr);
    gap:25px;
    margin-bottom:60px;

}

.inspection-page-card{

    background:white;
    border-radius:20px;
    padding:35px;
    box-shadow:0 12px 35px rgba(0,0,0,.06);
    transition:.3s;
    border-top:6px solid transparent;

}

.inspection-page-card:hover{

    transform:translateY(-8px);

}

.inspection-page-green{border-color:#16a34a;}
.inspection-page-yellow{border-color:#f59e0b;}
.inspection-page-red{border-color:#dc2626;}

.inspection-page-icon{

    font-size:40px;
    margin-bottom:20px;

}

.inspection-page-card h3{

    font-size:26px;
    margin-bottom:15px;
    color:#111827;

}

.inspection-page-card p{

    color:#6b7280;
    line-height:1.7;

}

/* Bottom */

.inspection-page-bottom{

    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.7) 100%), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    aspect-ratio: 4 / 3;
    background-size: contain;
    color:white;
    padding:45px;

    display:flex;
    justify-content:space-between;
    align-items:end;
    gap:40px;

}

.inspection-page-bottom p{

    font-size:24px;
    line-height:1.8;
    color:#d1d5db;

}

.inspection-page-btn{
    cursor:pointer;
    background:#E53935;
    color:white;
    text-decoration:none;
    padding:16px 32px;
    border-radius:50px;
    font-weight:700;
    white-space:nowrap;
    transition:.3s;

}

.inspection-page-btn:hover{

    background:#c62828;

}

/* Mobile */

@media(max-width:900px){

.inspection-page-cards{

grid-template-columns:1fr;

}

.inspection-page-bottom{

flex-direction:column;
text-align:center;

}

.inspection-page-title{

font-size:36px;
}
}
`, "",{"version":3,"sources":["webpack://./src/Inspection/css/Inspection.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA,YAAY;;AAEZ;;IAEI,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;;AAEf;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;;AAEtB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;;IAEI,cAAc;IACd,aAAa;IACb,eAAe;IACf,eAAe;IACf,kBAAkB;;AAEtB;;AAEA,UAAU;;AAEV;;IAEI,YAAY;IACZ,mCAAmC;IACnC,QAAQ;IACR,kBAAkB;;AAEtB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sCAAsC;IACtC,cAAc;IACd,gCAAgC;;AAEpC;;AAEA;;IAEI,0BAA0B;;AAE9B;;AAEA,uBAAuB,oBAAoB,CAAC;AAC5C,wBAAwB,oBAAoB,CAAC;AAC7C,qBAAqB,oBAAoB,CAAC;;AAE1C;;IAEI,cAAc;IACd,kBAAkB;;AAEtB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,aAAa;;AAEjB;;AAEA;;IAEI,aAAa;IACb,eAAe;;AAEnB;;AAEA,WAAW;;AAEX;;IAEI,oIAAmI;IACnI,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;IACX,YAAY;;IAEZ,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,QAAQ;;AAEZ;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,aAAa;;AAEjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;;IAEI,kBAAkB;;AAEtB;;AAEA,WAAW;;AAEX;;AAEA;;AAEA,yBAAyB;;AAEzB;;AAEA;;AAEA,qBAAqB;AACrB,iBAAiB;;AAEjB;;AAEA;;AAEA,cAAc;AACd;AACA","sourcesContent":[".inspection-page{\r\n    margin:0;\r\n    padding-top:90px;\r\n    box-sizing:border-box;\r\n    font-family:'Inter',sans-serif;\r\n    background:#f5f7fa;\r\n}\r\n\r\n/* SECTION */\r\n\r\n.inspection-page-section{\r\n\r\n    padding:90px 8%;\r\n    background:#ffffff;\r\n\r\n}\r\n\r\n.inspection-page-container{\r\n\r\n    max-width:1200px;\r\n    margin:auto;\r\n\r\n}\r\n\r\n.inspection-page-subtitle{\r\n\r\n    color:#E53935;\r\n    font-weight:700;\r\n    letter-spacing:2px;\r\n    text-transform:uppercase;\r\n    margin-bottom:15px;\r\n\r\n}\r\n\r\n.inspection-page-title{\r\n\r\n    font-size:48px;\r\n    font-weight:800;\r\n    color:#111827;\r\n    margin-bottom:20px;\r\n\r\n}\r\n\r\n.inspection-page-description{\r\n\r\n    font-size:18px;\r\n    color:#6b7280;\r\n    max-width:850px;\r\n    line-height:1.8;\r\n    margin-bottom:60px;\r\n\r\n}\r\n\r\n/* Cards */\r\n\r\n.inspection-page-cards{\r\n\r\n    display:grid;\r\n    grid-template-columns:repeat(3,1fr);\r\n    gap:25px;\r\n    margin-bottom:60px;\r\n\r\n}\r\n\r\n.inspection-page-card{\r\n\r\n    background:white;\r\n    border-radius:20px;\r\n    padding:35px;\r\n    box-shadow:0 12px 35px rgba(0,0,0,.06);\r\n    transition:.3s;\r\n    border-top:6px solid transparent;\r\n\r\n}\r\n\r\n.inspection-page-card:hover{\r\n\r\n    transform:translateY(-8px);\r\n\r\n}\r\n\r\n.inspection-page-green{border-color:#16a34a;}\r\n.inspection-page-yellow{border-color:#f59e0b;}\r\n.inspection-page-red{border-color:#dc2626;}\r\n\r\n.inspection-page-icon{\r\n\r\n    font-size:40px;\r\n    margin-bottom:20px;\r\n\r\n}\r\n\r\n.inspection-page-card h3{\r\n\r\n    font-size:26px;\r\n    margin-bottom:15px;\r\n    color:#111827;\r\n\r\n}\r\n\r\n.inspection-page-card p{\r\n\r\n    color:#6b7280;\r\n    line-height:1.7;\r\n\r\n}\r\n\r\n/* Bottom */\r\n\r\n.inspection-page-bottom{\r\n\r\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.7) 100%), url('../../../static/inspection.webp');\r\n    aspect-ratio: 4 / 3;\r\n    background-size: contain;\r\n    color:white;\r\n    padding:45px;\r\n\r\n    display:flex;\r\n    justify-content:space-between;\r\n    align-items:end;\r\n    gap:40px;\r\n\r\n}\r\n\r\n.inspection-page-bottom p{\r\n\r\n    font-size:24px;\r\n    line-height:1.8;\r\n    color:#d1d5db;\r\n\r\n}\r\n\r\n.inspection-page-btn{\r\n    cursor:pointer;\r\n    background:#E53935;\r\n    color:white;\r\n    text-decoration:none;\r\n    padding:16px 32px;\r\n    border-radius:50px;\r\n    font-weight:700;\r\n    white-space:nowrap;\r\n    transition:.3s;\r\n\r\n}\r\n\r\n.inspection-page-btn:hover{\r\n\r\n    background:#c62828;\r\n\r\n}\r\n\r\n/* Mobile */\r\n\r\n@media(max-width:900px){\r\n\r\n.inspection-page-cards{\r\n\r\ngrid-template-columns:1fr;\r\n\r\n}\r\n\r\n.inspection-page-bottom{\r\n\r\nflex-direction:column;\r\ntext-align:center;\r\n\r\n}\r\n\r\n.inspection-page-title{\r\n\r\nfont-size:36px;\r\n}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
